<template>
  <v-app-bar class="elevation-0 transparent" top flat>
    <v-toolbar-title>

      <v-btn :to="{ name: 'home' }" color="primary " depressed>
        <v-icon color="white">mdi-menu-left</v-icon>
        BACK TO GALLERY</v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-tabs background-color="transparent" height="100%" v-if="role == 'ADMIN'">
        <v-tab v-for="link in links" v-text="link.name" :key="link.name" router class="red--text"
          :to="{ name: link.route }"></v-tab>
      </v-tabs>
      <v-menu offset-y rounded="0">
        <template v-slot:activator="{ attrs, on }">
          <v-btn color="primary" small class="mb-2" v-bind="attrs" text v-on="on">
            {{ username }}
            <small class="ml-2">({{ displayRole }})</small>
            <v-icon right dark>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <!-- <v-list-item :to="{ name: '' }" dense> -->
          <!-- <v-list-item-content>Main Page</v-list-item-content> -->
          <!-- <div class="black--text white">Main Page</div> -->
          <!-- </v-list-item> -->

          <v-list-item @click="onLogout" link>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "Navbar",
  computed: mapGetters(["username", "displayRole", "role"]),
  data() {
    return {
      links: [
        { name: "Banners", route: "dashboard" },
        { name: "Advertisers", route: "dashboard.advertisers" },
        { name: "Categories", route: "dashboard.categories" },
        { name: "Views", route: "dashboard.views" },
        { name: "Administrators", route: "dashboard.admins" },
      ],
    };
  },
  methods: {
    ...mapActions(["logout"]),
    onLogout() {
      this.logout();
      this.$router.push({ name: "login" });
      location.reload();
    },
  },
});
</script>